import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';

import States from '../../../content/states.json';

import Grid from '../Grid';
import Text from '../Text';
import { mixins } from '../../settings';

import { StyledGridRow, StyledSelect, NamedDiv } from './styles';

class SelectState extends Component {
  static propTypes = {
    stateURL: PropTypes.string.isRequired
  };

  listStates = () => {
    return States.states.map((state) => {
      const url = mixins.formatURL(state);
      return (
        <option key={url} value={`${url}`}>
          {state}
        </option>
      );
    });
  };

  navigateToState = (e) => {
    window.location.href = `/nissandealers/location/${e.target.value}/`;
    let dropdownDtm = {
      name: 'dealer-state-filter',
      value: e.target.value
    }
    if (typeof _satellite !== 'undefined') {
      window.dtmTrackingDataLayer.event.dropdown = dropdownDtm;
      _satellite.track('dtmDropdownSelection', {
        dropdownDtm
      });
    }
  };

  render() {
    const { stateURL } = this.props;
    return (
      <div>
        <StyledGridRow>
          <Grid.Col xs={24}>
            <Text.Body>Select your location to see a list of Nissan dealerships in your area.</Text.Body>
          </Grid.Col>
          <Grid.Col xs={24} lg={12}>
            <Text.Body font="bold">Select your state</Text.Body>
            <form>
              <NamedDiv className="style-select">
                <StyledSelect value={stateURL} onChange={this.navigateToState}>
                  <option value="">State</option>
                  {this.listStates()}
                </StyledSelect>
              </NamedDiv>
            </form>
          </Grid.Col>
        </StyledGridRow>
      </div>
    );
  }
}

export default SelectState;
